// extracted by mini-css-extract-plugin
export default {"notificationList":"notification_list_notificationList__7+UyS","Mui-focused":"notification_list_Mui-focused__UF994","label":"notification_list_label__N+OJT"};